export const ADD_ACTION = '@global/add-action';
export const GET_API = '@global/get-api';

export const TIPO_DOCUMENTOS = [
    
    {
        value: 'Seleccione un tipo de documento',
        label: 'Seleccione un tipo de documento'
    },
    {
        value: 'CC',
        label: 'Cédula de ciudadania' 
    },
    {
        value: 'TE',
        label: 'Tarjeta de extranjeria'
    },
    {
        value: 'CE',
        label: 'Cédula de extranjeria'
    }, 
    {
        value: 'PP',
        label: 'Pasaporte'
    }, 
    {
        value: 'DNI',
        label: 'DNI'
    },
]
export const AVATAR_TYPES = ["image/png", "image/jpeg", "image/gif"];


export const EMAIL_FORMAT =  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const PASSWORD_FORMAT = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])([A-Za-z\d$@$!%*?&]|[^ ]){8,15}$/;
export const DOC_FORMAT =/^[0-9]+$/;
export const DOC_FORMAT_EXT = /^(?=.*?\d)(?=.*?[a-zA-Z])[a-zA-Z\d]+$/

